import PodcastDestinationLink, {
  PodcastDestinationLinkProps,
} from './PodcastDestinationLink';

export default PodcastDestinationLink;
export type { PodcastDestinationLinkProps };
